import { render, staticRenderFns } from "./TaxStatements.vue?vue&type=template&id=78f2ba1a&scoped=true&"
import script from "./TaxStatements.vue?vue&type=script&lang=js&"
export * from "./TaxStatements.vue?vue&type=script&lang=js&"
import style0 from "./TaxStatements.vue?vue&type=style&index=0&id=78f2ba1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78f2ba1a",
  null
  
)

export default component.exports